import { Pipe, PipeTransform } from '@angular/core';
import { TravelItinerary } from '../../../shared/models/travel-itinerary.model';

@Pipe({
	name: 'travelType',
})
export class TravelTypePipe implements PipeTransform {
	transform(value: string): string {
		return TravelItinerary.typeName(value);
	}
}
